import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { VotingPage } from './voting';
import { VotingComponentsModule } from './components/voting-component.module';

@NgModule({
  declarations: [
    VotingPage
  ],
  exports: [
    VotingPage
  ],
  imports: [
    IonicPageModule.forChild(VotingPage),
    VotingComponentsModule
  ],
})
export class VotingPageModule { }



// WEBPACK FOOTER //
// ./src/pages/voting/voting.module.ts